import { render, staticRenderFns } from "./add_model.vue?vue&type=template&id=6fdaa583&scoped=true&"
import script from "./add_model.vue?vue&type=script&lang=js&"
export * from "./add_model.vue?vue&type=script&lang=js&"
import style0 from "./add_model.vue?vue&type=style&index=0&id=6fdaa583&prod&lang=css&"
import style1 from "./add_model.vue?vue&type=style&index=1&id=6fdaa583&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdaa583",
  null
  
)

export default component.exports